/** Key used in sessionStorage to remember URL to redirect to after login */
export const REDIRECT_AFTER_LOGIN_KEY = "swobbee.portal.redirectAfterLogin";

/** Paths that are public (no login required); we don't save these for redirect */
export const PUBLIC_PATHS = ["/", "/reset-password", "/oauth2-signup", "/swobbee-locations"];
